import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { ArticleResponse } from './types';

type CreateArticleProps = {
  artistId: string;
  title?: string;
};

export async function createArticle({ artistId, title = 'Untitled Article' }: CreateArticleProps) {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/articles`;
  const response = await api.executePostRequest<ObjectResponse<ArticleResponse>>(url, { title });

  return response.data;
}
